module.exports = __webpack_public_path__ + "img/4.de2e8387.jpg";